"use client";
import { cn as i } from "../../../lib/utils.es.js";
import h from "../button/Button.es.js";
import { closeButtonClassNames as f } from "./Sheet.const.es.js";
import { jsx as a, jsxs as r } from "react/jsx-runtime";
import { cva as c } from "class-variance-authority";
import { X as p } from "lucide-react";
import * as l from "@radix-ui/react-dialog";
var u = l.Root, x = l.Trigger, O = l.Close, v = l.Portal, g = ({ className: t, side: e = "right", ...o }) => /* @__PURE__ */ a(l.Close, {
  asChild: !0,
  className: i("lib:absolute lib:size-6 lib:border lib:border-black lib:p-0 lib:hover:border-black/20 lib:md:size-18", e && f[e], t),
  ...o,
  children: /* @__PURE__ */ r(h, {
    tabIndex: -1,
    variant: "white",
    children: [/* @__PURE__ */ a(p, { className: "lib:size-4 lib:md:size-8" }), /* @__PURE__ */ a("span", {
      className: "lib:sr-only",
      children: "Закрыть"
    })]
  })
}), S = ({ className: t, ...e }) => /* @__PURE__ */ a(l.Overlay, {
  className: i("lib:data-[state=closed]:fade-out-0 lib:data-[state=open]:fade-in-0 lib:fixed lib:inset-0 lib:z-50 lib:bg-black/80 lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in", t),
  "data-slot": "sheet-overlay",
  ...e
}), C = c("lib:fixed lib:z-50 lib:gap-4 lib:bg-background lib:p-6 lib:shadow-lg lib:transition lib:ease-in-out lib:data-[state=closed]:animate-out lib:data-[state=open]:animate-in lib:data-[state=closed]:duration-300 lib:data-[state=open]:duration-500", {
  variants: {
    side: {
      top: "lib:data-[state=closed]:slide-out-to-top lib:data-[state=open]:slide-in-from-top lib:inset-x-0 lib:top-0 lib:border-b",
      bottom: "lib:data-[state=closed]:slide-out-to-bottom lib:data-[state=open]:slide-in-from-bottom lib:inset-x-0 lib:bottom-0 lib:border-t",
      left: "lib:data-[state=closed]:slide-out-to-left lib:data-[state=open]:slide-in-from-left lib:inset-y-0 lib:left-0 lib:h-full lib:w-full lib:border-r lib:md:w-3/4",
      right: "lib:data-[state=closed]:slide-out-to-right lib:data-[state=open]:slide-in-from-right lib:inset-y-0 lib:right-0 lib:h-full lib:w-full lib:border-l lib:md:w-3/4"
    },
    bottomOn: {
      md: i("lib:max-md:data-[state=closed]:slide-out-to-bottom lib:max-md:data-[state=open]:slide-in-from-bottom lib:max-md:animate-tr", "lib:max-md:data-[state=closed]:slide-out-to-right-0 lib:max-md:data-[state=open]:slide-in-from-right-0", "lib:max-md:data-[state=closed]:slide-out-to-left-0 lib:max-md:data-[state=open]:slide-in-from-left-0"),
      s: i("lib:max-s:data-[state=closed]:slide-out-to-bottom lib:max-s:data-[state=open]:slide-in-from-bottom lib:max-s:animate-tr", "lib:max-s:data-[state=closed]:slide-out-to-right-0 lib:max-s:data-[state=open]:slide-in-from-right-0", "lib:max-s:data-[state=closed]:slide-out-to-left-0 lib:max-s:data-[state=open]:slide-in-from-left-0"),
      false: null
    }
  },
  defaultVariants: {
    side: "right",
    bottomOn: !1
  }
}), N = ({ side: t = "right", bottomOn: e, withCloseButton: o = !0, className: d, children: b, closeButton: s = /* @__PURE__ */ a(g, { side: t }), ...n }) => {
  const m = typeof s == "function" ? s : () => s;
  return /* @__PURE__ */ r(v, { children: [/* @__PURE__ */ a(S, {}), /* @__PURE__ */ r(l.Content, {
    className: i(C({
      side: t,
      bottomOn: e
    }), d),
    "data-slot": "sheet-content",
    ...n,
    children: [o && m(t), b]
  })] });
}, j = ({ className: t, ...e }) => /* @__PURE__ */ a("div", {
  className: i("lib:flex lib:flex-col lib:space-y-2 lib:text-center lib:sm:text-left", t),
  "data-slot": "sheet-header",
  ...e
}), B = ({ className: t, ...e }) => /* @__PURE__ */ a("div", {
  className: i("lib:flex lib:flex-col-reverse lib:sm:flex-row lib:sm:justify-end lib:sm:space-x-2", t),
  "data-slot": "sheet-footer",
  ...e
}), D = ({ className: t, ...e }) => /* @__PURE__ */ a(l.Title, {
  className: i("lib:font-semibold lib:text-foreground lib:text-lg", t),
  "data-slot": "sheet-title",
  ...e
}), P = ({ className: t, ...e }) => /* @__PURE__ */ a(l.Description, {
  className: i("lib:text-muted-foreground lib:text-sm", t),
  "data-slot": "sheet-description",
  ...e
}), F = ({ children: t, open: e = !1, defaultOpen: o = !1, onOpenChange: d, className: b, trigger: s, ...n }) => /* @__PURE__ */ r(u, {
  defaultOpen: o,
  onOpenChange: d,
  open: e,
  children: [s && /* @__PURE__ */ a(x, {
    asChild: !0,
    children: s
  }), /* @__PURE__ */ a(N, {
    className: i("lib:space-y-4", b),
    ...n,
    children: t
  })]
});
export {
  N as SheetContent,
  F as UiSheet,
  O as UiSheetClose,
  g as UiSheetCloseButton,
  P as UiSheetDescription,
  B as UiSheetFooter,
  j as UiSheetHeader,
  D as UiSheetTitle,
  x as UiSheetTrigger
};
